const { appendReferralMiddleware } = require('./referral');

/**
 * Initialize all the middlewares
 */
function init() {
    appendReferralMiddleware();
}

module.exports = {
    init
};
